<template>
  <v-content>
    <header-bar />

    <router-view />
  </v-content>
</template>
<script>
import PublicHeaderBar from "../HeaderBar/PublicHeaderBar"
import HeaderBar from "../HeaderBar/HeaderBar"

export default {
  components: { HeaderBar, PublicHeaderBar }
}
</script>
